import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import fontIcons from "../../assets/font-glyphs/icons.json";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
	icon: {
		cursor: "pointer",
		display: "flex",
		borderRadius: 4,
		"&:hover": {
			background: "#43BD98",
			color: "white",
		},
	},
	selectedIcon: {
		background: "#43BD98",
		color: "white",
	},
	iconContainer: {
		maxHeight: "calc(100% - 60px)",
		overflow: "auto",
		justifyContent: "flex-start",
		"&::after": {
			content: "",
			flex: "auto",
		},
	},
	selectedOption: {
		textDecoration: "none",
		backgroundColor: "rgba(0, 0, 0, 0.04)",
	},
});

const allIcons = [
	"AntDesign",
	"Entypo",
	"EvilIcons",
	"Feather",
	"FontAwesome",
	"FontAwesome5",
	"Fontisto",
	"Foundation",
	"Ionicons",
	"MaterialCommunityIcons",
	"MaterialIcons",
	"Octicons",
	"SimpleLineIcons",
	"Zocial",
].map((f) => ({ name: f, icons: Object.entries(fontIcons[f]) }));

export default function IconModal({
	showIconMenu,
	setShowIconMenu,
	setPage,
	page = {},
}) {
	const classes = useStyles();
	const [selectedIconName, setSelectedIconName] = useState(page.iconName);
	const [selectedIconType, setSelectedIconType] = useState(page.iconType);
	const [search, setSearch] = useState("");
	const { t } = useTranslation();

	const Icon = React.memo(({ family, name, ...props }) => (
		<span
			style={{
				fontSize: 18,
				fontFamily:
					family === "FontAwesome5"
						? "'FontAwesome5', 'FontAwesome5_Regular', 'FontAwesome5Brands'"
						: family,
			}}
			{...props}
		>
			{String.fromCodePoint(fontIcons[family][name])}
		</span>
	));

	useEffect(() => {
		setSelectedIconName(page.iconName);
		setSelectedIconType(page.iconType);
	}, [page]);

	const handleClose = () => {
		setShowIconMenu(false);
	};

	const saveData = () => {
		page.iconName = selectedIconName;
		page.iconType = selectedIconType;
		console.log("SETTING PAGE");
		setPage(page);
		console.log(page);
		handleClose();
	};

	return (
		<div>
			<Modal open={showIconMenu} onClose={handleClose}>
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						width: 800,
						bgcolor: "background.paper",
						boxShadow: 24,
						p: 4,
						maxHeight: "calc(100% - 80px)",
					}}
				>
					<Typography id="modal-modal-title" variant="h6" component="h2">
						{t("favorites.modalTitle")}
					</Typography>
					<Grid
						container
						xs={12}
						spacing={2}
						alignContent="flex-start"
						sx={{ height: "calc(100vh - 207px)", marginBottom: 2 }}
					>
						<Grid item xs={4} sx={{ height: "100%", overflow: "auto" }}>
							<List>
								{allIcons.map((i, index) => (
									<ListItem disablePadding>
										<ListItemButton
											className={
												i.name === selectedIconType
													? classes.selectedOption
													: ""
											}
											onClick={() => {
												setSelectedIconType(i.name);
											}}
										>
											<ListItemText primary={i.name} />
										</ListItemButton>
									</ListItem>
								))}
							</List>
						</Grid>
						<Grid
							item
							xs={8}
							justifyContent="flex-start"
							alignItems="flex-start"
							alignContent="flex-start"
							container
							sx={{ maxHeight: "100%" }}
						>
							<TextField
								id="outlined-helperText"
								placeholder="Search icons..."
								fullWidth
								sx={{ marginBottom: 2 }}
								value={search}
								onChange={(e) => setSearch(e.target.value)}
							/>
							<Grid
								item
								xs={12}
								justifyContent="space-between"
								alignItems="center"
								container
								className={classes.iconContainer}
								style={{ "&::after": { content: "" } }}
								sx={{
									maxHeight: "100%",
									overflow: "auto",
									paddingBottom: 1,
								}}
							>
								{selectedIconType &&
									allIcons
										.find((i) => i.name === selectedIconType)
										.icons.filter((icon) =>
											icon[0].toLowerCase().includes(search.toLowerCase())
										)
										.map((icon) => (
											<Grid
												item
												xs={3}
												justifyContent="center"
												alignItems="center"
												sx={{ padding: 2 }}
												className={
													classes.icon +
													" " +
													(selectedIconName === icon[0]
														? classes.selectedIcon
														: "")
												}
												onClick={() => {
													setSelectedIconName(icon[0]);
												}}
											>
												<Icon family={selectedIconType} name={icon[0]} />
												{/*React.createElement(icon[1])*/}
											</Grid>
										))}
							</Grid>
						</Grid>
					</Grid>
					<Grid container xs={12} justifyContent="flex-end">
						<Button variant="contained" size="small" onClick={saveData}>
							{t("favorites.modalButton")}
						</Button>
					</Grid>
				</Box>
			</Modal>
		</div>
	);
}
